import * as Yup from 'yup';
import messages from './messages';

export function getCreateSiteValidationSchema(companyId, formatMessage) {
  return {
    name: Yup.string()
      .max(255, formatMessage(messages.createSiteModalValidationSchemaMaxLengthName))
      .required(formatMessage(messages.createSiteModalValidationSchemaRequired)),
  };
}
